module.exports = __webpack_public_path__ + "static/img/Ben.McDevitt.360d4c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben.McDevitt.jpg
// module id = PhGK
// module chunks = 0